import {Box} from "@material-ui/core";
import React from "react";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box  className="tab-panel-content">
                    {children}
                </Box>
            )}
        </div>
    );
}

export default TabPanel;
